import { SearchTerm } from './SearchTerm';

const SiteSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "siteName",
        translationKey: "name"
    },
    {
        heading: "Time Zone",
        accessor: "timeZone",
        searchOnName: "timeZone.zone",
        translationKey: "timeZone"
    },
];

export default SiteSearch;
